import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, BookOpenIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
interface PricingOfferProps {
  variant?: 'primary' | 'secondary';
}
export function PricingOffer({
  variant = 'primary'
}: PricingOfferProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const cartUrl = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
  return <section className={`py-16 px-4 ${variant === 'primary' ? 'bg-[#FAF7F2]' : 'bg-white'}`} ref={ref} data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-[#7C9A6E]/20" data-id="element-100">
          <div className="bg-gradient-to-r from-[#A0525A] to-[#8B4549] text-white text-center py-4 px-4" data-id="element-101">
            <p className="text-lg md:text-xl font-bold" data-id="element-102">
              ⚡ OFERTA ESPECIAL — SOLO POR TIEMPO LIMITADO
            </p>
          </div>

          <div className="p-6 md:p-10" data-id="element-103">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-104">
              <div className="order-2 md:order-1" data-id="element-105">
                <h3 className="text-2xl md:text-3xl font-bold text-[#2D2926] mb-4" data-id="element-106">
                  Guía Completa + 10 Bonos
                </h3>

                <div className="mb-6" data-id="element-107">
                  <PriceDisplay amount={14.99} originalAmount={97} data-id="element-108" />
                </div>

                <p className="text-[#2D2926]/70 mb-6" data-id="element-109">
                  Acceso inmediato y de por vida a todo el contenido
                </p>

                <motion.a href={cartUrl} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full bg-[#7C9A6E] hover:bg-[#6B8F5E] text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full text-center shadow-lg transition-colors mb-6" data-id="element-110">
                  ¡QUIERO MI GUÍA AHORA!
                </motion.a>

                <div className="flex items-center justify-center gap-4 text-[#2D2926]/60 text-sm mb-4" data-id="element-111">
                  <div className="flex items-center gap-1" data-id="element-112">
                    <ShieldCheckIcon className="w-4 h-4" data-id="element-113" />
                    <span data-id="element-114">Seguro</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-115">
                    <LockIcon className="w-4 h-4" data-id="element-116" />
                    <span data-id="element-117">Encriptado</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-118">
                    <CreditCardIcon className="w-4 h-4" data-id="element-119" />
                    <span data-id="element-120">Pago Fácil</span>
                  </div>
                </div>

                <p className="text-center text-sm text-[#2D2926]/60" data-id="element-121">
                  Pago 100% Seguro • Acceso Inmediato
                </p>
              </div>

              <div className="order-1 md:order-2" data-id="element-122">
                <div className="max-w-[280px] mx-auto rounded-2xl shadow-xl relative overflow-hidden" data-id="element-123">
                  <div className="absolute -top-3 -right-3 bg-[#A0525A] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg z-10" data-id="element-124">
                    -85% OFF
                  </div>
                  <img src="https://cdn.magicpatterns.com/uploads/n1g1nLCAtkuXFDdztGQg5D/20260303_1357_Image_Generation_remix_01kjta1ns7f79vkr2jyvcjcwbc.png" alt="Menopausia en Calma - Guía Completa + 10 Bonos" className="w-full h-auto rounded-2xl" data-id="element-125" />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#7C9A6E]/10 p-4 text-center" data-id="element-126">
            <div className="flex items-center justify-center gap-2 text-[#6B8F5E]" data-id="element-127">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-128" />
              <span className="font-semibold" data-id="element-129">
                7 DÍAS DE GARANTÍA — Sin riesgos
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}